import { GoalsApi } from "../../apis/goals.api";
import { LeadApi } from "../../apis/lead.api";
import { TAddUpdateLeadGoal } from "../../models/add-update-lead-goal";
import { withRxJs } from "../../components/hoc/with-rx";
import { GoalsComponent } from "./goals.component";
import { defaultGoalsProfile } from "../../constants/data.constant";
import { ModelPerformanceInput } from "../../lib/das-api/model/modelPerformanceInput";
import { AppApi } from "../../apis/app.api";
import { RemoteDataUtils } from "@assetmark/ui-kit/dist/utils/remote-data.utils";

const GoalsContainer = withRxJs(GoalsComponent)(() => {
	return {
		defaultProps: {
			goalsData: defaultGoalsProfile,
			savedLeadGoalsData : RemoteDataUtils.initial,
			onAddLeadGoal: (lead: TAddUpdateLeadGoal, currentRoute: string, lastPageVisited: string) => {
                GoalsApi.addLeadGoal(lead, currentRoute, lastPageVisited);
            },
			onUpdateLeadGoal: (goal: TAddUpdateLeadGoal, modelPerformanceInput: ModelPerformanceInput, currentRoute: string, lastPageVisited: string) => {
				GoalsApi.updateLeadGoal(goal, modelPerformanceInput, currentRoute, lastPageVisited);
			},
			// saveLeadGoalDataToLocal: (lead: TAddUpdateLeadGoal, nextPage: string) => {
            //     GoalsApi.saveLeadGoalDataToLocal(lead, nextPage);
            // },
			onBackButtonClick: (backScreen: string) => {
				LeadApi.redirectToPage$.next(backScreen);
			},
			onResetContextState: () => {
				GoalsApi.removeLeadGoalDataFromContext();
			}
		},
		
		props: {
			goalsData: GoalsApi.getSavedGoalsData$(),
			savedLeadGoalsData: AppApi.getGoalsData$(),
		},
	};
});

export default GoalsContainer;